<template>
  <b-row>
    <b-col class="border mx-2 p-3">
      <h3 class="mb-3">Product gallery</h3>

      <ul class="list-unstyled d-flex flex-wrap" style="gap: 1rem;">
        <li
          v-for="media in requestDetails.product_gallery_media"
          :key="media.id"
          class="d-flex flex-column"
          style="width: calc(25% - 0.75rem);"
        >
          <img
            v-if="media.mime_type.startsWith('image')"
            :src="media.url"
            :alt="media.file_name"
            class="w-100 mb-2"
          />
          <video
            v-else-if="media.mime_type.startsWith('video')"
            :src="media.url"
            class="w-100 mb-2"
          />
          <b-button variant="primary" size="sm" @click="downloadMedia(media.url)">Download</b-button>
        </li>
      </ul>
      <h3 class="mb-3">Supplier gallery</h3>

      <ul class="list-unstyled d-flex flex-wrap" style="gap: 1rem;">
        <li
          v-for="media in requestDetails.supplier_gallery_media"
          :key="media.id"
          class="d-flex flex-column"
          style="width: calc(25% - 0.75rem);"
        >
          <img
            v-if="media.mime_type.startsWith('image')"
            :src="media.url"
            :alt="media.file_name"
            class="w-100 mb-2"
          />
          <video
            v-else-if="media.mime_type.startsWith('video')"
            :src="media.url"
            class="w-100 mb-2"
          />
          <b-button variant="primary" size="sm" @click="downloadMedia(media.url)">Download</b-button>
        </li>
      </ul>

      <div class="d-flex">
        <div class="w-25">
          <h3 class="mb-3">Product video</h3>

          <div v-if="requestDetails.supplier_video_media" class="w-100 d-flex flex-column">
            <video
              :src="requestDetails.supplier_video_media.url"
              class="w-100 h-auto mb-2"
            />
            <b-button variant="primary" size="sm" @click="downloadMedia(requestDetails.supplier_video_media.url)">Download</b-button>
          </div>
        </div>

        <div class="w-75 ml-3">
          <h3 class="mb-3">About supplier</h3>

          <p
            v-html="requestDetails.about"
            class="w-100 h-auto"
          />
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { supplierRequests as supplierRequestsApi } from '@/api'

export default {
  name: 'SupplierDetails',

  components: { },

  props: {
    request: { type: Object },
  },

  data() {
    return {
      requestDetails: {},
    }
  },

  computed: {
  },

  mounted() {
    this.loadContent()
  },

  methods: {
    loadContent() {
      supplierRequestsApi.find(this.request.id)
        .then(response => {
          this.requestDetails = response.data
          this.$emit('loaded', false)
        })
    },

    downloadMedia(url) {
      const link = document.createElement('a')
      link.href = url
      link.download = 'download'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  },
}
</script>
